<template>
    <settings-editor-base
        v-bind:label="label"
    >
        <template v-slot="{inputId}">
            <select
                    v-bind:id="inputId"
                    v-model="model"

                    class="form-control"
            >
                <option v-if="placeholder">{{placeholder}}</option>

                <option
                    :key="option.value"
                    v-for="option in mappedOptions"
                    v-bind:value="option.value"
                >
                    {{option.text}}
                </option>
            </select>
        </template>
    </settings-editor-base>
</template>

<script>
    import SettingsEditorBase from "./SettingsEditorBase.vue";

    export default {
        name: "settings-dropdown",
        components: {SettingsEditorBase},
        computed: {
            mappedOptions(){
                const vm = this;

                if(vm.valueField){
                    const valueField = vm.valueField;
                    const textField = vm.textField || vm.valueField;
                    
                    return vm.options.map(o => ({ value: o[valueField], text: o[textField] }));
                }
                
                //Simply use our input options for display/value
                return vm.options.map(o => ({ value: o, text: o }));
            },
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            options: {
                type: Array
            },
            label: {
                type: String,
                required: true
            },
            textField: {
                type: String,
                default: ''
            },
            valueField: {
                type: String,
                default: ''
            },
            placeholder: String,
            value: undefined
        }
    };
</script>
